import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full h-full flex flex-col" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-center h-full",
  "data-testid": "dashboard-performa-loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_Loading)
        ]))
      : (_ctx.isError)
        ? (_openBlock(), _createBlock(_component_ErrorMessage, {
            key: 1,
            errorType: _ctx.errorCause,
            onTryAgain: _ctx.onRetry,
            "data-testid": "dashboard-performa-error"
          }, null, 8, ["errorType", "onTryAgain"]))
        : (_ctx.embedUrl)
          ? (_openBlock(), _createBlock("iframe", {
              key: 2,
              src: _ctx.embedUrl,
              referrerpolicy: "no-referrer",
              title: "Dashboard Performa",
              class: "w-full h-full border-0",
              "data-testid": "dashboard-performa-iframe",
              onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onIframeLoad && _ctx.onIframeLoad(...args)))
            }, null, 40, ["src"]))
          : _createCommentVNode("", true)
  ]))
}